var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
var FooterTop = function (props) {
    var navigationLinks = props.navigationLinks, children = props.children, className = props.className, 
    // @ts-ignore
    __TYPE = props.__TYPE, remainingProps = __rest(props, ["navigationLinks", "children", "className", "__TYPE"]);
    var displayNavigationLinkDetail = function (navLink) {
        return navLink.map(function (link, i) {
            return (React.createElement("li", { key: "navigation-detail-".concat(i) },
                React.createElement("a", { className: "fr-footer__top-link", href: link.link }, link.label)));
        });
    };
    var topLinks;
    topLinks = navigationLinks === null || navigationLinks === void 0 ? void 0 : navigationLinks.map(function (link, i) {
        return (React.createElement("div", { key: "navigation-link-".concat(i), className: "fr-col-12 fr-col-sm-3 fr-col-md-2" },
            React.createElement("h3", { className: "fr-footer__top-cat" }, link.category),
            link.linkDetails ? (React.createElement("ul", { className: "fr-footer__top-list" }, displayNavigationLinkDetail(link.linkDetails))) : null));
    });
    return (React.createElement("div", __assign({}, remainingProps, { className: "fr-footer__top" }),
        React.createElement("div", { className: "fr-container" },
            React.createElement("div", { className: "fr-grid-row fr-grid-row--start fr-grid-row--gutters" }, topLinks))));
};
FooterTop.defaultProps = { __TYPE: "FooterTop" };
FooterTop.propTypes = { __TYPE: PropTypes.string };
export default FooterTop;
